export function resolveEventStreamConfig(input) {
    const eventSigner = input.signer;
    const eventStreamPayloadHandler = input.eventStreamPayloadHandlerProvider({
        ...input,
        eventSigner,
    });
    return {
        ...input,
        eventSigner,
        eventStreamPayloadHandler,
    };
}
